export const LOAD_SESSION = 'LOAD_SESSION';
